<template>
  <div>
    <div class="form">
      <el-form ref="form" class="login-from" :model="formData" :rules="bindCheck" label-width="80px" validate>
        <el-form-item :label="emailName" prop="email">
          <el-input v-model="formData.email" size="small" autofocus placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="15">
            <el-form-item label="验证码" prop="verifyCode">
              <el-input v-model="formData.verifyCode" size="small" autofocus placeholder="邮箱验证码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-button v-if="!codeSend && !codeIsSend" size="small" type="info" style=" width: 100%;">获取验证码</el-button>
            <el-button v-else-if="codeSend && !codeIsSend" size="small" type="primary" style="width: 100%;" @click="showCode" :loading="loading">获取验证码</el-button>
            <el-button v-else-if="codeIsSend" type="info" size="small" disabled style="width: 100%;">{{count}}秒后重新发送</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class=“email-tips”>
      <div class="tips-box">
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog()">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmitstep('form')">{{submitBtnTxt}}</el-button>
    </span>
    <el-dialog width="480px" top="350px" title="提示" :visible.sync="innerVisible" append-to-body class="send-email-dialog">
      <div>
        <i class="iconfont icon-chenggong"></i>
        <span class="code-send-tip">验证码已发至<span class="code-send-email">「{{formData.email}}」</span></span>
      </div>
      <p class="send-time-tip">注：验证码仅一次有效～</p>
      <div style="text-align:center">
        <el-button type="primary" @click="innerVisible=false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const ruleEmail = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
import { httpAjax } from "@/api/ajax";
export default {
  name: 'EmailVerify',
  props: {
    submitBtnTxt:String,
    emailName:String
  },
  data() {
    const emailValidate = async(rule, value, callback) => {
      if(!ruleEmail.test(value)){
        this.codeSend = false;
        return callback(new Error('请输入正确邮箱'));
      }else{
        this.codeSend = true;
        callback();
      }
    };
    return {
		  formData:{
        email:'',
        verifyCode:''
      },
      loading:false,
      timer:null,
      count:0,
      codeIsSend:false,
      codeSend:false,
      bindCheck:{
        email: [{ required: true,type: 'email', message: '请输入正确的邮箱地址',validator: emailValidate, trigger: ['blur', 'change'] }],
        verifyCode: [{ required: true, message: '邮箱验证码', trigger: 'change' }],
      },
      innerVisible:false  //控制邮箱发送成功弹框显示与否
    }
  },
  methods: {
      // 提交
     onSubmitstep(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('success',this.formData)
        }
      });
    },
       // 显示验证码
    showCode() {
      if(this.formData.email === ''){
        this.$message({
          message: '请输入邮箱',
          type: 'error'
        })
        return;
      }
      this.loading = true
      httpAjax({
        url: '/services/verify/send/verifySms/email',
        method: "get",
        data:{email:this.formData.email}
      }).then((response) => {
        this.loading = false
        if (response.success) {
          this.codeIsSend = true;
          this.count = 60;
          this.timeFun();
          // this.$message({
          //   message: '验证码发送成功',
          //   type: 'success'
          // })
          this.innerVisible = true;
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      });
    },

    closeDialog(){
       this.$emit('onClose')
    },

       // 倒计时
    timeFun() {
      this.count = 60;
      this.timer = setInterval(() => {
        if(this.count === 1) {
          this.codeIsSend = false;
          clearInterval(this.timer);
        } else {
          this.count--;
        }
      }, 1000);
    },

  }
}
</script>

<style lang="less" scoped>
.email-tips {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.dialog-footer {
  text-align: center;
}
.send-email-dialog {
  /deep/.el-dialog__title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #111111;
  }
  /deep/.el-dialog__body {
    padding: 10px 20px 16px 20px;
  }
  .icon-chenggong {
    font-size: 24px;
    color: #1e8e3eff;
  }
  .code-send-tip {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #111111;
    position: relative;
    top: -3px;
    left: 10px;
  }
  .code-send-email {
    color: #00a0e9ff;
  }
  .send-time-tip {
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    color: #666666;
    margin-left: 34px;
  }
  /deep/.el-button--primary {
    height: 32px;
    width: 80px;
    line-height: 32px;
    padding: 0;
    margin: 36px 0 0 0;
  }
}
</style>